// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { xSiteMessage } from "@west/XDL/Utilities";
import React from "react";

interface MoreOptionsAvailableStyles {
    moreOptionsLink?: LinkPresentationProps;
}

export const moreOptionsAvailableStyles: MoreOptionsAvailableStyles = {};

interface OwnProps {
    showPlaceholder?: boolean;
    onClick?: () => void;
}

type Props = OwnProps & HasProduct;

const styles = moreOptionsAvailableStyles;

const MoreOptionsAvailable = ({ product, showPlaceholder = false, onClick }: Props) => {
    const isHidden = !product.isVariantParent;

    if (isHidden && !showPlaceholder) {
        return null;
    }

    const onClickHandler = () => {
        // TODO: the user is navigated to the base product PDP but with the child product selected
        onClick?.();
    };

    return <Link {...styles.moreOptionsLink}>{xSiteMessage("Custom_more_options_available")}</Link>;
};

export default withProduct(MoreOptionsAvailable);
